/*
Copyright MITSUBISHI Elec.
*/

BlenderCalendar.DT_MASK = "%Y/%m/%d";
BlenderCalendar.IN_MASK = "%Y%m%d";
BlenderCalendar.DT_MASK_SHOWTIME = "%Y/%m/%d %h:%M";
BlenderCalendar.IN_MASK_SHOWTIME = "%Y%m%d%h%M";
BlenderCalendar.DEFAULT_TEXT_MAX_LENGTH = 8;
BlenderCalendar.SHOWTIME_TEXT_MAX_LENGTH = 12;

/**
 * ## BlenderCalendar
 * 日付設定カレンダコンポーネント。
 *
 * @class BlenderCalendar
 * @extends BlenderComponent
 * @module BlenderCalendar
 * @constructor
 * @param obj {string/object} タグID
 */
function BlenderCalendar(obj) {
	this.tagId = (isString(obj) ? obj : obj.tagId);
	this.textFld = (isString(obj) ? $("#"+obj) : obj);
	this.icon = null;
	this.editableFlg;
	this.requiredFlg = true;
	this.handlerId = null;
	this.prevVal = null;

	this.afterCalendar = null;
	this.beforeCalendar = null;

	this.dt_mask = BlenderCalendar.DT_MASK;
	this.in_mask = BlenderCalendar.IN_MASK;

	this.calendar = null;
	this.calendarDiv = null;
	this.iframeDiv = null;
	this.showCalendarFlg = false;

	this.setEditable( false );

	if ( BlenderCalendarSettings.KEEP_INVALID_DATE ) {
		// maxlengthを初期化
		this.textMaxLength = BlenderCalendar.DEFAULT_TEXT_MAX_LENGTH;
	}

	BlenderComponent.call(this, this.tagId, "blender");

}

// Extends
BlenderCalendar.inherit(BlenderComponent);

/**
 * アイコンと関連付ける。
 * 関連付けられたアイコンをクリックすることで、入力カレンダーが
 * 表示可能となる。
 * @method attachIcon
 * @param id アイコン用タグID
 */
BlenderCalendar.prototype.attachIcon = function(id) {
	this.icon = $("#"+id);
	var self = this;
	this.icon.click(function(){
		self.show();
	});
}

/**
 * 編集可否を設定する。
 * @method setEditable
 * @param flg 編集可能な場合true、不可能な場合false
 */
BlenderCalendar.prototype.setEditable = function(flg) {
	if( flg ) {
		this.textFld.removeAttr( "readonly" );
	}else {
		this.textFld.attr( "readonly", "readonly" );
	}
	this.editableFlg = flg;
}

/**
 * 入力必須可否を設定する。
 * @method setRequired
 * @param flg 入力必須な場合true、入力必須ではない場合false
 */
BlenderCalendar.prototype.setRequired = function(flg) {
	this.requiredFlg = flg;
}

/**
 * 後カレンダーを設定する。
 * @method setAfterCalendar
 * @param calendar 後カレンダー
 */
BlenderCalendar.prototype.setAfterCalendar = function(calendar) {
	this.afterCalendar = calendar;
	this.beforeCalendar = null;

	var self = this;

	self.attachEvent("valueChanged", function(){
		self._changedDate();
	});
}

/**
 * 前カレンダーを設定する。
 * @method setBeforeCalendar
 * @param calendar 前カレンダー
 */
BlenderCalendar.prototype.setBeforeCalendar = function(calendar) {
	this.beforeCalendar = calendar;
	this.afterCalendar = null;

	var self = this;

	self.attachEvent("valueChanged", function(){
		self._changedDate();
	});
}

/**
 * 初期化を行う。
 * [拡張機能]のパラメータは、blendercalendarobjectをインクルードする必要があります。
 *
 * @method init
 * @param params オプション指定パラメータ連想配列({
 * 							time: 時刻表示(true|false),
 * 							minutesInterval: 分間隔の指定(1,5,10,15),
 * 							swapYearMonthPos: 年、月表示位置入替(true|false),
 * 							useOkButton: [OK]ボタン表示(true|false)[拡張機能],
 * 							useFlexMinutesInterval: 分の拡張モード追加(true|false)[拡張機能]}),
 * 							useSelectionStyle: 年月時分のセレクタを<select>スタイルに変更(true|false)[拡張機能]})
 */
BlenderCalendar.prototype.init = function(params) {
	var bodyPanel = $("#bodyPanel");

	var self = this;

	var zIndex = dhx4.zim.reserve();

	this.calendarDiv = bodyPanel.find("#bl_calendarDiv_"+this.tagId);
	if( this.calendarDiv.length == 0 ) {
		this.calendarDiv = $("<div id='bl_calendarDiv_"+this.tagId+"' "+
			"style='position:absolute;left:0px;top:0px;display:none;z-index:"+(zIndex+1)+"'>"+
			"</div>");
		bodyPanel.append(this.calendarDiv);

		this.iframeDiv = $("<iframe id='bl_calendarIfr_"+this.tagId+"' "+
			"style='position:absolute;left:0px;top:0px;width:170px;height:166px;display:none;z-index:"+zIndex+"'>"+
			"</iframe>");
		bodyPanel.append(this.iframeDiv);
	} else {
		this.iframeDiv = bodyPanel.find("#bl_calendarIfr_"+this.tagId);
	}
	var visibleTime = ( params && "time" in params ) ? params["time"] : false;
	var minutesInterval = ( params && "minutesInterval" in params ) ? params["minutesInterval"] : 5;
	if ( params && "skin" in params ) this.skin = params["skin"];
	this.calendar = new dhtmlxCalendarObject("bl_calendarDiv_"+this.tagId, this.skin);
//	if (this.skin=="blender_jquery" && !( params && "useSelectionStyle" in params )) params["useSelectionStyle"] = true;

	// 機能拡張を行う
	if (typeof (BlenderCalendarObject) != "undefined" && BlenderCalendarObject.extendFunction) {
		BlenderCalendarObject.extendFunction(this.calendar, params);
	}

	this.calendar.setMinutesInterval(minutesInterval);
	this.calendar.langData = BlenderDhtmlxCustomSettings.langData;
	if ( params && "lang" in params ) {
		this.calendar.loadUserLanguage(params["lang"]);
	}else {
		for(var key in this.calendar.langData){
			this.calendar.loadUserLanguage(key);
			break;
		}
	}
	this.fromDate = BlenderDateUtil.parseDate(BlenderCalendarSettings.FROM_DATE, "%Y/%m/%d");
	this.toDate = BlenderDateUtil.parseDate(BlenderCalendarSettings.TO_DATE + " 23:59:59", "%Y/%m/%d %h:%M:%s");

	this.calendar.enableIframe(true);
	if ( visibleTime ) {
		this.dt_mask = BlenderCalendar.DT_MASK_SHOWTIME;
		this.in_mask = BlenderCalendar.IN_MASK_SHOWTIME;
		this.calendar.setDateFormat("%Y/%m/%d %H:%i");
		this.textMaxLength = BlenderCalendar.SHOWTIME_TEXT_MAX_LENGTH;
		this.calendar.setMinutesInterval(minutesInterval);
		this.calendar.showTime();
	}else {
		this.calendar.hideTime();
	}
	this.calendar.hideWeekNumbers();

	this.calendar.setSensitiveRange(this.fromDate, this.toDate);

	$(document.body).click(function(){
		// カレンダー表示のタイミングでなければカレンダー消去
		if( !self.showCalendarFlg ) {
			self.calendarDiv.css( "display", "none" );
			self.iframeDiv.css( "display", "none" );
			if( self.handlerId ) {
				self.calendar.detachEvent(self.handlerId);
				self.handlerId = null;
			}
		}
		self.showCalendarFlg = false;
	});

	this.calendarDiv.css( "visibility", "hidden" );
	this.iframeDiv.css( "visibility", "hidden" );


	if ( BlenderCalendarSettings.KEEP_INVALID_DATE ) {
		// 指定の文字数制限を設定する
		if (this.textMaxLength) {
			this.textFld.attr("maxlength", this.textMaxLength);
		}
	}

	this.textFld.focus(function(e) {
		if( !self.editableFlg ) {
			return;
		}

		var dtStr = self.textFld.val();
		this.prevVal = dtStr;

		var dt = BlenderDateUtil.parseDate(dtStr,(self.dt_mask||BlenderCalendar.DT_MASK));
		dtStr = BlenderDateUtil.formatDate(dt,(self.in_mask||BlenderCalendar.IN_MASK));

		if ( BlenderCalendarSettings.KEEP_INVALID_DATE ) {
			// 正常な日付以外の値が設定されている場合でも、空値に変換せずに保持する
			var isNonValidDt = BlenderValidator.checkDate(this.prevVal, (self.dt_mask||BlenderCalendar.DT_MASK));
			self.textFld.val( (isNonValidDt ? this.prevVal : dtStr) );

		} else {
			self.textFld.val( (null != dtStr ? dtStr : "") );
		}
		self.textFld.select();
	});

	this.textFld.blur(function(e) {
		if( !self.editableFlg ) {
			return;
		}

		var findErr = false;
		var date = null;

		var inMask = (self.in_mask||BlenderCalendar.IN_MASK);

		var tmp = self.textFld.val();
		if( tmp ) {
			if( inMask==="%Y%m%d" && tmp.match(/^\d{8}$/) ) {
				var yyyy = eval(tmp.substring(0,4));
				var mm = eval(tmp.substring(4,6));
				var dd = eval(tmp.substring(6,8));
				var tmpDate = new Date(yyyy, mm-1, dd);
				//var tmpDate = BlenderDateUtil.parseDate(tmp,inMask);

				if( tmpDate.getFullYear()==yyyy
				 && (tmpDate.getMonth()+1)==mm
				 && tmpDate.getDate()==dd ) {
					date = tmpDate;

					if (self.fromDate && self.toDate && (date < self.fromDate || self.toDate < date)) {
						findErr = true;
					}
				}else {
					findErr = true;
				}
			}else if( inMask==="%Y%m%d%h%M" && tmp.match(/^\d{12}$/) ) {
				var yyyy = eval(tmp.substring(0,4));
				var mm = eval(tmp.substring(4,6));
				var dd = eval(tmp.substring(6,8));
				var hh = eval(tmp.substring(8,10));
				var mi = eval(tmp.substring(10,12));
				var tmpDate = new Date(yyyy, mm-1, dd, hh, mi);
				//var tmpDate = BlenderDateUtil.parseDate(tmp,inMask);

				if( tmpDate.getFullYear()==yyyy
				 && (tmpDate.getMonth()+1)==mm
				 && tmpDate.getDate()==dd
				 && tmpDate.getHours()==hh
				 && tmpDate.getMinutes()==mi ) {
					date = tmpDate;

					if (self.fromDate && self.toDate && (date < self.fromDate || self.toDate < date)) {
						findErr = true;
					}
				}else {
					findErr = true;
				}
			}else {
				findErr = true;
			}
		}else {
			if( self.requiredFlg ) findErr = true;
		}

		if ( !BlenderCalendarSettings.KEEP_INVALID_DATE ) {
			// 一旦前の値に戻す
			self.textFld.val( this.prevVal );
		}

		if( !findErr ) {
			if( date ) {
				self.setDate( self.calendar.getFormatedDate(null, date) );
			}else {
				self.setDate( "" );

				if ( BlenderCalendarSettings.KEEP_INVALID_DATE ) {
					if (this.prevVal != "") {
						// 空値に変更された場合は、変更イベントを呼ぶ(ModifyChecker等を更新する)
						self._notifyEvent({ type : "valueChanged", src : self, value : "" });
					}
				}
			}
		} else {

			if (BlenderCalendarSettings.KEEP_INVALID_DATE) {
				// 値が変更された場合は変更イベントを呼ぶ(ModifyChecker等を更新する)
				if (this.prevVal != tmp) {
					self._notifyEvent({ type : "valueChanged", src : self, value : tmp });
				}
			} else {
				if (self.requiredFlg) {
					self.setDate(this.prevVal);
				} else {
					self.setDate("");
				}
			}
		}
		return (!findErr);
	});

	this.unload = function() {
//		self.calendar.unload();
		self.calendarDiv.remove();
		self.iframeDiv.remove();
	}

}

/**
 * カレンダーを表示する。
 * @method show
 */
BlenderCalendar.prototype.show = function() {
	var val = this.textFld.val();

	// 日付として正しいフォーマットの値かをチェックする
	var isValidDt = true;
	if (BlenderCalendarSettings.KEEP_INVALID_DATE) {
		isValidDt = !BlenderValidator.checkDate(val, (this.dt_mask || BlenderCalendar.DT_MASK));
	}

	if( val && val.length>0 && isValidDt ) {

		// dhtmlxcalendarのsetDateに日付文字列を渡すと、ミリ秒部分が残存するため、
		// Dateオブジェクト(時刻以下全て0)に変換してから渡すよう変更
		var _targetdate = BlenderDateUtil.parseDate(val, (this.dt_mask || BlenderCalendar.DT_MASK));

		//期間範囲チェックで、dhtmlxが時刻を0時に丸めているため、00:01～23:59の時刻が上限エラーになり該当日が適用されないため、1日伸ばす
		var frDate = new Date();
		frDate.setTime(this.calendar._rangeFrom);
		var toDate = new Date();
		toDate.setTime(this.calendar._rangeTo+86400000);
		this.calendar.setSensitiveRange(frDate, toDate);

		if (BlenderCalendarSettings.KEEP_INVALID_DATE
				&& (!this.textMaxLength  || 8 < this.textMaxLength)) {
			// 不正値保持かつテキスト桁数8文字超過の入力が可能な場合のみ、範囲外日付のチェック
			// (Valid判定される形式で入力される可能性がある ex.「2100/01/01」)
			if (this.calendar._isOutOfRange(_targetdate)) {
				_targetdate = new Date();
			}
		}

		this.calendar.setDate(_targetdate);

		//範囲チェックの上限を戻す
		toDate.setTime(this.calendar._rangeTo-86400000);
		this.calendar.setSensitiveRange(frDate, toDate);
	}else {
		this.calendar.setDate(new Date());
	}

	var self = this;

	this.handlerId = this.calendar.attachEvent("onClick",function(){
		var date = self.calendar.getDate();

		self.setDate( self.calendar.getFormatedDate(null,date) );

		self.calendarDiv.css( "display", "none" );
		self.iframeDiv.css( "display", "none" );
		if( self.handlerId ) {
			self.calendar.detachEvent(self.handlerId);
			self.handlerId = null;
		}
		self.showCalendarFlg = false;
	});
  
	var offset = this.icon.offset();
	var offTop = 0;
	var offH = window.innerHeight - offset.top;
	if(offH<178){
		offTop = 178 - offH;
	}
	var calIfrWidth = (this.calendar._ifr.style.width) ? parseInt(this.calendar._ifr.style.width) : 198;
	if (calIfrWidth<=0) calIfrWidth = 198;
	var offLeft = 0;
	var offW = window.innerWidth - offset.left;
	if(offW<calIfrWidth){
		offLeft = calIfrWidth - offW;
	}
	this.calendarDiv
		.css( "left", offset.left - offLeft )
		.css( "top", offset.top - offTop )
		.css( "visibility", "visible" )
		.css( "display", "block" );
	this.iframeDiv
		.css( "left", offset.left+4 - offLeft )
		.css( "top", offset.top+2 - offTop )
		.css( "visibility", "visible" )
		.css( "display", "block" );
	this.showCalendarFlg = true;
	this.calendar.show();
	self.calendar.base.style.display = "";
}

/**
 * 日付変更後処理を実行する。
 * 「前日付>後日付」だった場合、対象カレンダーの日付補正を行う。
 * @method _changedDate
 */
BlenderCalendar.prototype._changedDate = function() {
	var targetCalendar;
	var afterTime = null;
	var beforeTime = null;

	if (this.beforeCalendar || !this.afterCalendar) {
		// 前カレンダーのみ設定
		targetCalendar = this.beforeCalendar;

		var beforeDate = BlenderDateUtil.parseDate(this.beforeCalendar.val(), this.dt_mask||BlenderCalendar.DT_MASK);
		if (beforeDate && (beforeDate instanceof Date)) {
			beforeTime = beforeDate.getTime();
		}

		afterTime = BlenderDateUtil.parseDate(this.val(), this.dt_mask||BlenderCalendar.DT_MASK);
	} else if (!this.beforeCalendar || this.afterCalendar) {
		// 後カレンダーのみ設定
		targetCalendar = this.afterCalendar;

		beforeTime = BlenderDateUtil.parseDate(this.val(), this.dt_mask||BlenderCalendar.DT_MASK);

		var afterDate = BlenderDateUtil.parseDate(this.afterCalendar.val(), this.dt_mask||BlenderCalendar.DT_MASK);
		if (afterDate && (afterDate instanceof Date)) {
			afterTime = afterDate.getTime();
		}
	} else {
		return;
	}

	if (!beforeTime || !afterTime) {
		return;
	} else if (beforeTime > afterTime) {
		if (!BlenderCalendarSettings.KEEP_INVERSE_RANGE) {
			targetCalendar.val(this.val());
		}
	}
}

/**
 * 日付を取得する。
 * @method getDate
 * @return 設定された日付文字列(yyyy/MM/dd)
 */
BlenderCalendar.prototype.getDate = function() {
	return this.textFld.val();
}

/**
 * 日付を設定する。
 * @method setDate
 * @param val 設定する日付文字列(yyyy/MM/dd) or 日付オブジェクト
 */
BlenderCalendar.prototype.setDate = function(val) {
	if ( typeof val == "object" ){
		val = BlenderDateUtil.formatDate(val,(this.dt_mask||BlenderCalendar.DT_MASK));
	}

	var self = this;

	var prevVal = this.getDate();

	this.textFld.val((val ? val : ""));

	if( prevVal != val ) {
		this._notifyEvent({type:"valueChanged", src:self, value:val});
	}
}

/**
 * 値を取得/設定する。
 * ※BlenderModifyChecker対応用メソッド
 * @method val
 * @param value 値
 * @return 値
 */
BlenderCalendar.prototype.val = function(value) {
	if ( value === undefined ) {
		return this.getDate();
	}else {
		this.setDate(value);
	}
}

/**
 * 保存値を取得/設定する。
 * ※BlenderModifyChecker対応用メソッド
 * @method savedVal
 * @param value 値
 * @return 値
 */
BlenderCalendar.prototype.savedVal = function(value) {
	return this.textFld.savedVal(value);
}

/**
 * 日付が設定されていた場合、その日付を１日前に戻す。
 * setSensitiveRange により設定可能範囲が指定されていた場合、
 * 戻した日がfrom日より前になる場合はto日に変更する。
 * @method prev
 */
BlenderCalendar.prototype.prev = function() {
	var date = BlenderDateUtil.parseDate(this.val(), this.dt_mask||BlenderCalendar.DT_MASK);
	if( !date ) return;

	date.setDate(date.getDate() - 1);

	if( this.calendar._rangeFrom && this.calendar._rangeFrom > date ) {
		if( this.calendar._rangeTo ) date = new Date(this.calendar._rangeTo);
	}

	this.val(date);
}

/**
 * 日付が設定されていた場合、その日付を１日後に進める。
 * setSensitiveRange により設定可能範囲が指定されていた場合、
 * 進めた日がto日より後になる場合はfrom日に変更する。
 * @method next
 */
BlenderCalendar.prototype.next = function() {
	var date = BlenderDateUtil.parseDate(this.val(), this.dt_mask||BlenderCalendar.DT_MASK);
	if( !date ) return;

	date.setDate(date.getDate() + 1);

	if( this.calendar._rangeTo && this.calendar._rangeTo < date ) {
		if( this.calendar._rangeFrom ) date = new Date(this.calendar._rangeFrom);
	}

	this.val(date);
}

/**
 * 設定されているSensitiveRangeを破棄する。
 * @method clearSensitiveRange
 */
BlenderCalendar.prototype.clearSensitiveRange = function() {
	this.calendar.clearSensitiveRange();
}

/**
 * 設定可能な日付範囲を指定する。
 * @method setSensitiveRange
 * @param from 開始日(日付オブジェクトあるいは文字列。文字列の場合はDT_MASKに依存)
 * @param to 終了日(日付オブジェクトあるいは文字列。文字列の場合はDT_MASKに依存)
 * @param ins 不明(仕様記載なし)
 */
BlenderCalendar.prototype.setSensitiveRange = function(from, to, ins) {
	this.calendar.setSensitiveRange(from, to, ins);
}

/**
 * 設定不可能な日付範囲を指定する。
 * @method setInsensitiveRange
 * @param from 開始日(日付オブジェクトあるいは文字列。文字列の場合はDT_MASKに依存)
 * @param to 終了日(日付オブジェクトあるいは文字列。文字列の場合はDT_MASKに依存)
 */
BlenderCalendar.prototype.setInsensitiveRange = function(from, to) {
	this.calendar.setInsensitiveRange(from, to);
}

/**
 * 値変更イベントハンドラを設定する。
 * ※BlenderModifyChecker対応用メソッド
 * @method change
 * @param func 値変更イベントハンドラ
 */
BlenderCalendar.prototype.change = function(func) {
	this.attachEvent("valueChanged", func);
}

/**
 * クラスの有無を確認する。
 * ※BlenderModifyChecker対応用メソッド
 * @method hasClass
 * @param className クラス名
 */
BlenderCalendar.prototype.hasClass = function(className) {
	return this.textFld.hasClass(className);
}

/**
 * クラスを追加する。
 * ※BlenderModifyChecker対応用メソッド
 * @method addClass
 * @param className クラス名
 */
BlenderCalendar.prototype.addClass = function(className) {
	this.textFld.addClass(className);
}

/**
 * クラスを削除する。
 * ※BlenderModifyChecker対応用メソッド
 * @method removeClass
 * @param className クラス名
 */
BlenderCalendar.prototype.removeClass = function(className) {
	this.textFld.removeClass(className);
}

/**
 * カレンダーテキスト部分のmaxlengthを指定する
 *
 * @method setTextMaxLength
 * @param length 最大入力文字数(数値)
 */
BlenderCalendar.prototype.setTextMaxLength = function(length) {
	if (BlenderCalendarSettings.KEEP_INVALID_DATE) {
		if (!length || isNumber(length)) {
			// 空値または数値の場合に受け付ける
			this.textMaxLength = length;
			this.textFld.attr("maxlength", this.textMaxLength);
		}
	}
};

/**
 * スキンを設定する。s
 *
 * @method setSkin
 * @param skin スキン名
 */
BlenderCalendar.prototype.setSkin = function(skin) {
	this.skin = skin;
	if (this.calendar) {
		this.calendar.setSkin(skin);
	}
};

/*
Copyright MITSUBISHI Elec.
*/
